export const red50 = "#fae8e9";
export const red100 = "#f9d7db";
export const red200 = "#f3afb7";
export const red300 = "#ee8894";
export const red400 = "#e86070";
export const red500 = "#e3394d";
export const red600 = "#d72d3d";
export const red700 = "#ca222e";
export const red800 = "#bf161e";
export const red900 = "#b30b0f";
export const red1000 = "#9e0204";
export const redA100 = "#f9668a";
export const redA200 = "#f15573";
export const redA400 = "#d51c26";
export const redA500 = "#be0406";
export const redA1000 = "#4f131a";
